import { soapLabels } from '@/shared/constants/const'
import { shouldUseSpecialFormat } from '@/features/formatter/utils/soapFormatter'
import { type YakurekiDetail } from '@/shared/types/yakurekiCore'
import { type SoapContentItem } from '@/shared/types/yakurekiSoap'

import { SOAP_SECTIONS } from './soapSections'

// SOAP 本体のコピー文字列を組み立てる純関数群 (テスト対象)。採否は is_selected フィールドを
// 唯一の起点にする (= 訪問報告書 homeVisitFields.selectedText と同じ規約)。is_selected が
// 明示されない行は採用扱い (?? true) にフォールバックする。format は formatSoapText の
// 通常/特別 format 規約を踏襲する。

const isSelected = (item: SoapContentItem) => item.is_selected ?? true

// section 単独コピー (= 見出しクリック時). 採用行のみを改行連結する。
export const buildSoapSectionText = (items: SoapContentItem[]): string =>
  items
    .filter(isSelected)
    .map((item) => item.content)
    .join('\n')

// 全文コピー. 採用行のみを、 通常 format は 【ラベル】+本文、 特別 format は本文のみを
// section 区切りで連結する。採用行が無い section はブロックごと落とす。
export const buildSoapCopyText = (soaps: YakurekiDetail['soaps']): string => {
  const special = shouldUseSpecialFormat()
  const sections = SOAP_SECTIONS.map(({ key }) => {
    const items = (soaps?.[key] ?? []) as SoapContentItem[]
    const content = buildSoapSectionText(items)
    if (content.length === 0) return ''
    return special ? content : `${soapLabels[key]}\n${content}`
  }).filter(Boolean)
  return sections.join(
    special ? '\n--------------------------------------\n' : '\n'
  )
}
